import styled from 'styled-components';

const EventsTabs = styled.div`
  display: flex;
  list-style: none;
  border-bottom: 1px solid #d5e5f0;
`;

const EventsList = styled.button`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #4f6168;
  margin-right: 32px;
  padding: 0px 16px;
  height: 44px;

  &:hover {
    cursor: pointer;
    color: #5b36f2;
    background: #e2dffd;
  }

  &:focus {
    background: #c6c0fc;
  }
`;

const TapText = styled.p`
  &:hover {
    border-bottom: 1px solid #5b36f2;
  }

  &:focus {
    border-bottom: 1px solid #5b36f2;
  }
`;
const DropDown = styled.div`
  width: 168px;
  border-radius: 4px;
  padding: 8px 8px 8px 16px;
  border: 1px solid #7a959f;
  background: #ffffff;
  margin-top: 16px;
`;

const CardButton = styled.button`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;

  &:hover {
    background: #d5e5f0;
  }

  &:focus {
    background: #a8cbe2;
  }

  @media (min-width: 1280px) {
    width: 360px;
  }

  &.eventoCancelado {
    pointer-events: none;
    span,
    p {
      color: #8090bb;
    }
    div {
      color: #8090bb;
    }
    span {
      border-color: #8090bb;
    }
    img {
      filter: brightness(1);
      filter: saturate(0);
    }
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #d5e5f0;
  height: 64px;
  padding: 12px;
  gap: 6px;
`;

const CardTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: left;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
`;

const CardText1 = styled.div`
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 24px;
  background: #e2d9ff;
  color: #5b36f2;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`;

const Icons = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const FeaturedIcon = styled.img`
  width: 24px;
  height: 20px;
  margin-right: 12px;
`;

const CardBody = styled.div`
  display: flex;
  width: 100%;
  // height: calc(100% - 56px);
`;

const BodyIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 89px;
  height: 100px;
`;

const BodyContent = styled.div`
  padding: 14px 12px 0px 12px;
  width: calc(100% - 89px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-left: 1px solid #d5e5f0;
  @media (min-width: 992px) {
    // width: 68%;
  }
`;

const EventIcon = styled.img`
  margin: 14.3px 13px;
`;
const CardCalendar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const CardDays = styled.div`
  // display: flex;
  list-style: none;
  // margin-bottom: 10px;
`;

const CardClock = styled.div`
  display: flex;
  align-items: center;
`;

const CardRemote = styled.div`
  display: flex;
  justify-content: space-between;

  @media (min-width: 992px) {
    // margin-right: 0;
  }
`;

const SelectContainer = styled.div`
  width: 100%;
  height: 45px;
  background: #ffffff;
  margin: 24px 0px;
  border-radius: 4px;

  @media (min-width: 768px) {
    width: 168px;
  }
`;

export {
  EventsTabs,
  EventsList,
  TapText,
  DropDown,
  CardButton,
  CardHeader,
  CardTitle,
  CardText1,
  Icons,
  CardBody,
  BodyIcon,
  EventIcon,
  BodyContent,
  FeaturedIcon,
  CardCalendar,
  CardDays,
  CardClock,
  CardRemote,
  SelectContainer
};
